var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import PCLNAnalytics from '@pcln/analytics';
var Analytics = /** @class */ (function () {
    function Analytics() {
        this.pclnAnalytics = PCLNAnalytics;
    }
    Analytics.prototype.init = function (data) {
        this.chatbotContext = data;
    };
    // fire GA4 event
    Analytics.prototype.fireGA4Event = function (ga4EventParams) {
        this.pclnAnalytics.GA4Enabled = true;
        this.pclnAnalytics.logEvent(ga4EventParams);
    };
    // Log an error
    // sample query 'index=cheetah component=PennyChatbot action=error'
    Analytics.prototype.logError = function (logData) {
        this.pclnAnalytics.logError(__assign(__assign({}, this.getBaseAttributes()), logData));
    };
    // Log directly to Splunk
    // sample query 'index=cheetah component=PennyChatbot'
    Analytics.prototype.log = function (logData) {
        this.pclnAnalytics.log(__assign(__assign({}, this.getBaseAttributes()), logData));
    };
    Analytics.prototype.getBaseAttributes = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        return {
            component: 'PennyChatbot',
            requestFrom: (_c = (_b = (_a = this.chatbotContext) === null || _a === void 0 ? void 0 : _a.fetchRequestOptions) === null || _b === void 0 ? void 0 : _b.headers) === null || _c === void 0 ? void 0 : _c['x-request-from'],
            productId: (_e = (_d = this.chatbotContext) === null || _d === void 0 ? void 0 : _d.submitChatMessagesPayload) === null || _e === void 0 ? void 0 : _e.productId,
            cguid: (_g = (_f = this.chatbotContext) === null || _f === void 0 ? void 0 : _f.submitChatMessagesPayload) === null || _g === void 0 ? void 0 : _g.cguid,
            rguid: (_j = (_h = this.chatbotContext) === null || _h === void 0 ? void 0 : _h.submitChatMessagesPayload) === null || _j === void 0 ? void 0 : _j.rguid,
        };
    };
    return Analytics;
}());
export default new Analytics();
//# sourceMappingURL=index.js.map